import React from 'react';
import { Link } from 'gatsby';
import Select from 'react-select';
// import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { colors } from '../styles/theme';
import { WhiteBlock } from '../styles/WhiteBlock';

const sortBy = [
  { value: 'Last Opened', label: 'Last Opened' },
  { value: 'Last Modified', label: 'Last Modified' },
  { value: 'Most Recent', label: 'Most Recent' },
];

const Workspaces = () => (
  <Layout>
    <SEO title="Create Workspace" />
    <div className="db-area-main">
      <div className="db-container">
        <a href="#!" className="db-back-link button-chevron-left">
          <img src="/img/chevron-left.svg" alt="chevron" /> Back to the
          dashboard
        </a>

        <WhiteBlock style={{ marginBottom: 60 }}>
          <div className="create-wrokspace padding-30">
            <div className="flex-row align-items-center">
              <div className="col col-8">
                <h1>Create workspace to get started</h1>
                <p>
                  Get started by selecting your own workspaces or create new
                </p>
              </div>
              <div className="col col-4">
                <div className="text-right">
                  <Link href="/create-workspaces/" className="button">
                    Create Workspace
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </WhiteBlock>

        <div className="flex-row">
          <div className="col col-6">
            <h2 className="db-heading">All Workspaces</h2>
          </div>
          <div className="col col-6">
            <div className="workspace-filters flex-row no-margin">
              <Select className="custom-select" options={sortBy} />
              <button type="button" className="tile-filter">
                <img src="/img/thumbnails.svg" alt="" />
              </button>
              <button type="button" className="tile-filter">
                <img src="/img/hamburger.svg" alt="" />
              </button>
            </div>
          </div>
        </div>

        <div className="flex-row">
          <button type="button" className="single-wrokspace-tile">
            <WhiteBlock className="padding-30">
              <div className="workspace-logo">
                <img src="/img/behance-logo.png" alt="behance" />
              </div>

              <div className="worksapce-desc">
                <h4>Behance Portfolio</h4>

                <div className="workspace-people">
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-1.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-2.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-3.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>

                  <a href="#!" className="total-persons">
                    +4
                  </a>
                </div>
              </div>
            </WhiteBlock>
          </button>
          <button type="button" className="single-wrokspace-tile">
            <WhiteBlock className="padding-30">
              <div className="workspace-logo">
                <img src="/img/dribbble.svg" alt="dribbble" />
              </div>

              <div className="worksapce-desc">
                <h4>Dribbble Portfolio</h4>

                <div className="workspace-people">
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-1.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-2.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-3.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>

                  <a href="#!" className="total-persons">
                    +4
                  </a>
                </div>
              </div>
            </WhiteBlock>
          </button>
          <button type="button" className="single-wrokspace-tile">
            <WhiteBlock className="padding-30">
              <div
                className="workspace-logo"
                style={{
                  backgroundColor: colors.lightGreen,
                  color: colors.green,
                }}>
                TW
              </div>

              <div className="worksapce-desc">
                <h4>Test Workspace</h4>

                <div className="workspace-people">
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-1.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-2.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-3.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>

                  <a href="#!" className="total-persons">
                    +4
                  </a>
                </div>
              </div>
            </WhiteBlock>
          </button>
          <button type="button" className="single-wrokspace-tile">
            <WhiteBlock className="padding-30">
              <div
                className="workspace-logo"
                style={{
                  backgroundColor: colors.lightYellow,
                  color: colors.Yellow,
                }}>
                ET
              </div>

              <div className="worksapce-desc">
                <h4>Ecommerce Team</h4>

                <div className="workspace-people">
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-1.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-2.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-3.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>

                  <a href="#!" className="total-persons">
                    +4
                  </a>
                </div>
              </div>
            </WhiteBlock>
          </button>
          <button type="button" className="single-wrokspace-tile">
            <WhiteBlock className="padding-30">
              <div
                className="workspace-logo"
                style={{
                  backgroundColor: colors.lightRed,
                  color: colors.red,
                }}>
                FT
              </div>

              <div className="worksapce-desc">
                <h4>Frontend Team</h4>

                <div className="workspace-people">
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-1.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-2.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-3.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>

                  <span className="total-persons">+4</span>
                </div>
              </div>
            </WhiteBlock>
          </button>
          <button type="button" className="single-wrokspace-tile">
            <WhiteBlock className="padding-30">
              <div
                className="workspace-logo"
                style={{
                  backgroundColor: colors.lightGreen,
                  color: colors.green,
                }}>
                TW
              </div>

              <div className="worksapce-desc">
                <h4>Test Workspace</h4>

                <div className="workspace-people">
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-1.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-2.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>
                  <div className="single-person">
                    <span className="perosn-photo">
                      <img src="/img/person-3.jpg" alt="" />
                    </span>
                    <span className="person-name">Lorem Ipsum</span>
                  </div>

                  <a href="#!" className="total-persons">
                    +4
                  </a>
                </div>
              </div>
            </WhiteBlock>
          </button>
        </div>
      </div>
    </div>
  </Layout>
);

export default Workspaces;
